import * as HttpService from './http.service';
import { GET_QUEUE_JOBS_URL } from './url.service';

export const getQueueJobRecords = () => HttpService.getWithAuth(GET_QUEUE_JOBS_URL, false);
